import { Box } from '@mui/material';
import NotificationLink from 'src/features/inAppNotifications/presentation/components/NotificationLink';
import { InAppNotification } from 'src/types/common';

interface ModalNotificationContentProps {
  notification: InAppNotification;
  onClick?: () => void;
}

const ModalNotificationContent: React.FC<ModalNotificationContentProps> = ({
  notification,
  onClick: handleClick,
}) => {
  const image = (
    <Box
      component="img"
      src={notification.action_content}
      alt={notification.title || 'Notification Image'}
      sx={{
        width: '100%',
        height: 'auto',
        maxHeight: '60vh',
        objectFit: 'contain',
        borderRadius: (theme) => `${theme.shape.borderRadius * 2}px`,
      }}
    />
  );

  return (
    <NotificationLink onClick={handleClick} url={notification.action_data.url}>
      {image}
    </NotificationLink>
  );
};

export default ModalNotificationContent;
